import { BottomServiceVariants } from './types';

/*  eslint-disable-next-line @typescript-eslint/no-unused-vars */
const mapVariantToColor = (_variant: BottomServiceVariants) => Styles.color.black;

export const buttonColor = mapVariantToColor;
